// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m3TDg{display:block;color:inherit;text-decoration:none}.VhCQt{padding:8px 16px;list-style:none}", ""]);
// Exports
exports.locals = {
	"menuLink": "m3TDg",
	"pro": "VhCQt"
};
module.exports = exports;
